import { useLoaderData } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { usePaciente } from './hooks/usePaciente';
import { useDatosGenerales } from './hooks/useDatosGenerales';

import { PacienteEditarForm } from './components/PacienteEditarForm';
import { Error, Forbidden, Loader } from '../../components';

export async function loader({ params }) {
  return params.id;
}

export const PacienteEditar = () => {

  const id = useLoaderData();

  const { permisos } = useSelector(state => state.auth);

  const { pacienteQuery: { isLoading: isLoadingPaciente, isError: isErrorPaciente, data: paciente } } = usePaciente(id);

  const { datosGeneralesQuery: { isLoading: isLoadingConfiguracionDatosGenerales, isError: isErrorConfiguracionDatosGenerales, data: configuracionDatosGenerales } } = useDatosGenerales();

  return (permisos.pacienteUpdate) ? (
    <>
      {(isLoadingPaciente || isLoadingConfiguracionDatosGenerales)
        ? <Loader />
        : <>
          {(isErrorPaciente || isErrorConfiguracionDatosGenerales)
            ? <Error />
            : <>
              <PacienteEditarForm paciente={paciente} configuracionDatosGenerales={configuracionDatosGenerales} />
            </>
          }
        </>
      }
    </>
  ) : <div className='mt-3'><Forbidden /></div>
}
